import { Text } from '@adc/parallax-component-library';
import { FormContainer, Input, InputPassword, PasswordInputValidator } from 'Components/utility';
import i18n from 'Utilities/i18n';

import { ContentContainer, type CreateAccountFormDefinition } from '../helpers';

type RegisterMinorAccountProps = {
  formController: CreateAccountFormDefinition;
  identities?: Identity[];
  onValidate: (meetsReqs: boolean) => void;
};

function RegisterMinorAccount({
  formController,
  identities,
  onValidate,
}: RegisterMinorAccountProps) {
  const { errors, values, touched, handleChange, handleBlur } = formController;

  return (
    <ContentContainer>
      <Text>
        {i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.primaryText')}
      </Text>
      <FormContainer hasHiddenUserInput>
        <Input
          aria-label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.label'
          )}
          placeholder={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.placeholder'
          )}
          label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.label'
          )}
          errorMessage={errors.email}
          isInvalid={Boolean(errors.email && touched.email)}
          testID="email"
          value={values.email}
          onChangeText={handleChange('email')}
          onBlur={handleBlur('email')}
          inputMode="email"
        />
        <PasswordInputValidator
          placeholder={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.placeholder'
          )}
          label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.label'
          )}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur('password')}
          onChangeText={handleChange('password')}
          password={values.password}
          onValidate={onValidate}
          identities={identities}
          testID="password"
        />
        <InputPassword
          placeholder={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.placeholder'
          )}
          label={i18n.t(
            'CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.label'
          )}
          isInvalid={Boolean(errors.confirmPassword && touched.confirmPassword)}
          errorMessage={errors.confirmPassword}
          testID="confirmPassword"
          onBlur={handleBlur('confirmPassword')}
          onChangeText={handleChange('confirmPassword')}
          defaultValue={values.confirmPassword}
        />
      </FormContainer>
    </ContentContainer>
  );
}

export { RegisterMinorAccount };
